<section class="creations-manager">
  <div class="page-header">
    <div>
      <p class="eyebrow">Content</p>
      <h1>Creations Manager</h1>
      <p class="page-intro">
        Upload and organise project images that will appear on the Bourne
        Bespoke creations page.
      </p>
    </div>
  </div>

  <div class="creations-layout">
    <div class="panel panel-form">
      <div class="panel-header">
        <h2>Add New Creation</h2>
        <p>Upload an image, add tags, and prepare it for the front-end site.</p>
      </div>

      <form [formGroup]="creationForm" (ngSubmit)="submitCreation()">
        <div class="form-grid">
          <div class="form-group form-group--full">
            <label for="creation-image">Creation Image</label>

            <div class="upload-box">
              <input
                id="creation-image"
                type="file"
                accept="image/*"
                (change)="onFileSelected($event)"
              />

              <div class="upload-box__content" *ngIf="!imagePreview">
                <span class="upload-icon">+</span>
                <p>Select an image to upload</p>
                <small
                  >Recommended: high quality landscape or portrait image</small
                >
              </div>

              <div class="image-preview" *ngIf="imagePreview">
                <img [src]="imagePreview" alt="Selected creation preview" />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="title">Title</label>
            <input
              id="title"
              type="text"
              formControlName="title"
              placeholder="e.g. Walnut Media Wall"
            />
            <small
              class="error"
              *ngIf="
                creationForm.get('title')?.invalid &&
                creationForm.get('title')?.touched
              "
            >
              Title is required.
            </small>
          </div>

          <div class="form-group">
            <label for="altText">Alt Text</label>
            <input
              id="altText"
              type="text"
              formControlName="altText"
              placeholder="Describe the image for accessibility"
            />
            <small
              class="error"
              *ngIf="
                creationForm.get('altText')?.invalid &&
                creationForm.get('altText')?.touched
              "
            >
              Alt text is required.
            </small>
          </div>

          <div class="form-group form-group--full">
            <label for="description">Description</label>
            <textarea
              id="description"
              rows="4"
              formControlName="description"
              placeholder="Add a short description of this creation"
            ></textarea>
          </div>

          <div class="form-group form-group--full">
            <label for="tagSelect">Tags</label>

            <div class="tag-input-wrap">
              <select
                id="tagSelect"
                [(ngModel)]="selectedTag"
                [ngModelOptions]="{ standalone: true }"
              >
                <option value="">Select a category</option>
                <option *ngFor="let tag of availableTagOptions" [value]="tag">
                  {{ tag }}
                </option>
              </select>

              <button
                type="button"
                class="btn-secondary"
                (click)="addTag()"
                [disabled]="!selectedTag"
              >
                Add Tag
              </button>
            </div>

            <div class="tags-list" *ngIf="tags.length">
              <span
                class="tag-pill"
                *ngFor="let tag of tags; let i = index; trackBy: trackByTag"
              >
                {{ tag.label }}
                <button type="button" (click)="removeTag(i)">×</button>
              </span>
            </div>
          </div>

          <div class="form-group form-group--full">
            <label class="checkbox-row">
              <input type="checkbox" formControlName="featured" />
              <span>Mark as featured creation</span>
            </label>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn-primary" type="submit">Save Creation</button>
        </div>
      </form>
    </div>

    <div class="panel panel-list">
      <div class="panel-header">
        <h2>Existing Creations</h2>
        <p>A first preview of how uploaded items could be managed.</p>
      </div>

      <div class="creation-list">
        <article
          class="creation-card"
          *ngFor="let item of existingCreations; trackBy: trackByCreation"
        >
          <div class="creation-card__image">
            <ng-container *ngIf="item.imagePreview; else placeholderImage">
              <img [src]="item.imagePreview" [alt]="item.altText" />
            </ng-container>

            <ng-template #placeholderImage>
              <div class="creation-card__placeholder">
                {{ item.fileName || "No image" }}
              </div>
            </ng-template>
          </div>

          <div class="creation-card__content">
            <div class="creation-card__top">
              <h3>{{ item.title }}</h3>
              <span class="featured-badge" *ngIf="item.featured">Featured</span>
            </div>

            <p>{{ item.description }}</p>

            <div class="tags-list">
              <span class="tag-pill static" *ngFor="let tag of item.tags">
                {{ tag }}
              </span>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>
